export default __webpack_public_path__ + "static/media/wordpress.60c46399.svg";